import React, { useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { cancelButtonStyle, confirmButtonStyle, useStyles } from './styles';
import CLOSE_ICON from '../../../../assets/svg/close-icon.svg';
import { Dialog, Grid } from '@mui/material';
import Button from '../../../../components/Button/Button';
import CustomCheckBox from '../../../../components/CheckBox/CheckBox';
import { LANG_TEXT } from '../../../../constants/language';
import { useSettingsContext } from '../../../../context/SettingsContext';

interface ModalCustomProps {
  value: string;
  setValue: (newValue: string) => void;
  open: boolean;
  handleClose: () => void;
  handleSubmitRegion: (newValue: string) => void;
}

const CustomModal: React.FC<ModalCustomProps> = ({ value, setValue, open, handleClose, handleSubmitRegion }) => {
  const { stadiumData } = useSettingsContext();
  const classes = useStyles();
  const { t } = useTranslation();
  const [tempValue, setTempValue] = useState<string>('');

  useEffect(() => {
    if (open) {
      setTempValue(value);
    }
  }, [open, value]);

  const zones = useMemo(() => (stadiumData?.zones || []).map((zone, index) => ({ ...zone, id: index })), [stadiumData]);
  const handleConfirm = () => {
    setValue(tempValue);
    handleSubmitRegion(tempValue);
  };

  return (
    <Dialog className={classes.Modal} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box className={classes.Box}>
        <Box className={classes.BoxHeader}>
          <Box className={classes.TitleModal}>
            <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
              {t(LANG_TEXT.PARKING_LOT)}
            </Typography>
            <Typography fontSize={14} lineHeight={'20px'} color={'var(--Gray-600, #475467)'}>
              {t(LANG_TEXT.PARKING_LOT_TITLE)}
            </Typography>
          </Box>
          <Box className={classes.Icon} onClick={handleClose}>
            <img src={CLOSE_ICON} height={20} width={20} alt="CLOSE_ICON" />
          </Box>
        </Box>
        <Box className={classes.BoxContent}>
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
            {zones.map((zone, index) => (
              <Grid item xs={6} sm={6} md={6} key={index}>
                <Box className={classes.Items}>
                  <Box className={classes.BoxZone}>
                    <Typography fontSize={24} fontWeight={600} lineHeight={'32px'} color={'var(--Gray-900, #101828)'}>
                      {zone.mapValue}
                    </Typography>
                    <Typography fontSize={16} lineHeight={'24px'} color={'var(--Gray-600, #475467)'}>
                      {zone.zoneName}
                    </Typography>
                  </Box>
                  <CustomCheckBox value={zone.mapValue} checked={tempValue === zone.mapValue} setValue={setTempValue} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box className={classes.BoxFooter}>
          <Button
            id="cancel_button"
            fullWidth={false}
            title={t(LANG_TEXT.CANCEL)}
            buttonStyle={cancelButtonStyle}
            sxTextStyle={{ color: 'var(--Gray-700, #344054)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={handleClose}
          />
          <Button
            id="confirm_button"
            fullWidth={false}
            title={t(LANG_TEXT.CONFIRM)}
            buttonStyle={confirmButtonStyle}
            sxTextStyle={{ color: 'var(--Base-White, #FFF)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={handleConfirm}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default CustomModal;
